import warning from "warning"
import { normalize as normalizeModel } from "src/engine/modules/model/helpers"
import process from "./process"

const INITIAL_STATE = {
  model: null,
  items: {},
}

export default function entity(state = INITIAL_STATE, action) {
  const { model } = action

  const { name } = normalizeModel(model)

  warning(
    state.model === null || state.model === model,
    `Entity '${name}' already exists in store and it is different`,
  )

  const { id } = action

  const nextProcess = process(state.items[id], action)

  return nextProcess === state.items[id]
    ? state
    : {
        ...state,
        items: {
          ...state.items,
          [id]: nextProcess,
        },
      }
}
